import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListSubheader: Components<Theme>['MuiListSubheader'] = {
  defaultProps: {
    // controls left and right padding
    disableGutters: false,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '0',
      margin: '16px 0 8px',
      '&:first-of-type': {
        marginTop: '0',
      },
      ...theme.typography.body,
      color: theme.palette.text.primary,
    }),
    gutters: {
      // match size of ListItem
      padding: '0 4px',
    },
  },
};
